import { render } from "./Aluno.vue?vue&type=template&id=22ba7ef5"
import script from "@/assets/js/aluno.js?vue&type=script&lang=js"
export * from "@/assets/js/aluno.js?vue&type=script&lang=js"

import "./Aluno.vue?vue&type=style&index=0&id=22ba7ef5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__